import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import(
  /* webpackChunkName: "order-builder-ite-shell-style" */ "./iteShellStyle.scss"
);
import InsertLink from "@material-ui/icons/InsertLink";
import { has, head, set } from "lodash";
import LinkOff from "@material-ui/icons/LinkOff";
import testModel from "../../../../assets/img/ModelTest.png";

const ITEShellStyle = ({
  iteShellStyleLeft,
  iteShellStyleRight,
  selectedShellStyleRight,
  setSelectedShellStyleRight,
  selectedShellStyleLeft,
  setSelectedShellStyleLeft,
  leftSelected,
  rightSelected,
  iteModelLinked,
  selectedModelLeft,
  selectedModelRight,
  iteModelForOrder,
  selectedPresetRight,
  selectedPresetLeft,
}) => {
  // const [activeRightITEShellStyle, setActiveRightITEShellStyle] = useState();
  // const [activeLeftITEShellStyle, setActiveLeftITEShellStyle] = useState();

  const [hasSetDefaultLeft, setHasSetDefaultLeft] = useState(false);
  const [hasSetDefaultRight, setHasSetDefaultRight] = useState(false);
  const [linked, setLinked] = useState(true);

  const [hasSetPresetLeft, setHasSetPresetLeft] = useState(false);
  const [hasSetPresetRight, setHasSetPresetRight] = useState(false);

  useEffect(() => {
    // console.log("selectedPresetLeft", selectedPresetLeft);
    if (
      selectedPresetLeft !== "manual" &&
      selectedPresetLeft !== null &&
      selectedPresetLeft !== undefined
    ) {
      const hasShellStylePresetLeft = selectedPresetLeft.PresetValues.some(
        (preset) => preset.ValueType === "ShellStyle"
      );
      if (hasShellStylePresetLeft) {
        setHasSetPresetLeft(true);
        const shellStylePresetLeft = selectedPresetLeft.PresetValues.find(
          (preset) => preset.ValueType === "ShellStyle"
        );
        const shellStyleFromList = iteShellStyleLeft.find(
          (s) => s.Code === shellStylePresetLeft.OptionValue
        );
        setSelectedShellStyleLeft(shellStyleFromList);
      } else {
        setHasSetPresetLeft(false);
      }
    } else {
      setHasSetPresetLeft(false);
    }
  }, [selectedPresetLeft, selectedModelLeft]);

  useEffect(() => {
    // console.log("selectedPresetRight", selectedPresetRight);
    if (
      selectedPresetRight !== "manual" &&
      selectedPresetRight !== null &&
      selectedPresetRight !== undefined
    ) {
      const hasShellStylePresetRight = selectedPresetRight.PresetValues.some(
        (preset) => preset.ValueType === "ShellStyle"
      );
      if (hasShellStylePresetRight) {
        setHasSetPresetRight(true);
        const shellStylePresetRight = selectedPresetRight.PresetValues.find(
          (preset) => preset.ValueType === "ShellStyle"
        );
        const shellStyleFromList = iteShellStyleRight.find(
          (s) => s.Code === shellStylePresetRight.OptionValue
        );
        setSelectedShellStyleRight(shellStyleFromList);
      } else {
        setHasSetPresetRight(false);
      }
    } else {
      setHasSetPresetRight(false);
    }
  }, [selectedPresetRight, selectedModelRight]);

  useEffect(() => {
    // Reset shell style on left model change
    // console.log("useEffect: iteShellStyleLeft has changed", iteShellStyleLeft);
    setHasSetDefaultLeft(false);
  }, [iteShellStyleLeft]);

  useEffect(() => {
    // Reset shell style on right model change
    // console.log("useEffect: iteShellStyleRight has changed", iteShellStyleRight);
    setHasSetDefaultRight(false);
  }, [iteShellStyleRight]);

  useEffect(() => {
    if (!hasSetPresetLeft || !hasSetPresetRight) {
      const modelNameToMatch = "Soft Silicone Mould";
      const defaultShellCode = "Full";

      const isRightModelMatched =
        iteModelForOrder?.rightName?.includes(modelNameToMatch);
      const defaultShellStyleRight = iteShellStyleRight?.find((s) =>
        s.Code.includes(defaultShellCode)
      );

      const isLeftModelMatched =
        iteModelForOrder?.leftName?.includes(modelNameToMatch);
      const defaultShellStyleLeft = iteShellStyleLeft?.find((s) =>
        s.Code.includes(defaultShellCode)
      );

      // console.log("selectedShellStyleLeft", selectedShellStyleLeft);
      // console.log("defaultShellStyleLeft", defaultShellStyleLeft);
      if (
        leftSelected &&
        isLeftModelMatched &&
        defaultShellStyleLeft &&
        !hasSetDefaultLeft &&
        selectedShellStyleLeft.Code !== defaultShellStyleLeft.Code
      ) {
        // console.log(">>> Setting default shell style for left side");
        setSelectedShellStyleLeft(defaultShellStyleLeft);
        setHasSetDefaultLeft(true);
      } else if (
        !isLeftModelMatched &&
        !hasSetDefaultLeft &&
        iteShellStyleLeft?.length > 0
      ) {
        let selectedShellStyleTemp = head(iteShellStyleLeft);
        // console.log(
        //   ">>> Else if - Setting first shell style for left side",
        //   selectedShellStyleTemp
        // );
        setSelectedShellStyleLeft(selectedShellStyleTemp);
        setHasSetDefaultLeft(true);
      }

      // console.log("selectedShellStyleRight", selectedShellStyleRight);
      // console.log("defaultShellStyleRight", defaultShellStyleRight);

      if (
        rightSelected &&
        isRightModelMatched &&
        defaultShellStyleRight &&
        !hasSetDefaultRight &&
        selectedShellStyleRight.Code !== defaultShellStyleRight.Code
      ) {
        // console.log(">>> Setting default shell style for right side");
        setSelectedShellStyleRight(defaultShellStyleRight);
        setHasSetDefaultRight(true);
      } else if (
        !isRightModelMatched &&
        !hasSetDefaultRight &&
        iteShellStyleRight?.length > 0
      ) {
        let selectedShellStyleTemp = head(iteShellStyleRight);
        // console.log(
        //   ">>> Else if - Setting first shell style for right side",
        //   selectedShellStyleTemp
        // );
        setSelectedShellStyleRight(selectedShellStyleTemp);
        setHasSetDefaultRight(true);
      }
    }
  }, [
    iteModelForOrder,
    iteShellStyleLeft,
    iteShellStyleRight,
    leftSelected,
    rightSelected,
    selectedShellStyleLeft,
    selectedShellStyleRight,
    hasSetDefaultLeft,
    hasSetDefaultRight,
    selectedModelLeft,
    selectedModelRight,
  ]);

  // Set shell style for order
  // Set other side if still linked
  // const setRightActive = (shellStyle) => {
  //   setActiveRightITEShellStyle(shellStyle);

  //   if (linked && iteModelLinked) {
  //     setActiveLeftITEShellStyle(shellStyle);
  //   }
  // };

  // const setLeftActive = (shellStyle) => {
  //   setActiveLeftITEShellStyle(shellStyle);
  //   if (linked && iteModelLinked) {
  //     setActiveRightITEShellStyle(shellStyle);
  //   }
  // };

  const handleShellStyleChangeRight = (event) => {
    const selectedShell = event.target.value;
    // console.log("handleShellStyleChangeRight selectedShell", selectedShell);

    const selectedShellStyleRight = iteShellStyleRight?.find((s) =>
      s.Code === selectedShell
    );

    // console.log("selectedShell", selectedShell);
    // console.log("selectedShellStyleRight", selectedShellStyleRight);

    // console.log("handleShellStyleChangeRight", selectedShellStyleRight);
    setSelectedShellStyleRight(selectedShellStyleRight);
    if (linked && iteModelLinked) {
      setSelectedShellStyleLeft(selectedShellStyleRight);
    }
  };

  const handleShellStyleChangeLeft = (event) => {
    const selectedShell = event.target.value;
    // console.log("handleShellStyleChangeLeft selectedShell", selectedShell);

    const selectedShellStyleLeft = iteShellStyleLeft?.find((s) =>
      s.Code === selectedShell
    );
    // console.log("handleShellStyleChangeLeft", selectedShellStyleLeft);
    setSelectedShellStyleLeft(selectedShellStyleLeft);
    if (linked && iteModelLinked) {
      setSelectedShellStyleRight(selectedShellStyleLeft);
    }
  };

  return (
    <div>
      {(iteShellStyleLeft || iteShellStyleRight) &&
        (rightSelected || leftSelected) && (
          <div className="ite-shell-style-component-main-div order-builder-component">
            <Row className="order-builder-component-title">
              <Col xs={4}>
                <h2>Choose a shell style</h2>
              </Col>
              <Col xs={8}>
                <Row>
                  <Col xs={5}>
                    {rightSelected && (
                      <p className="right-ear-title ear-impression-option ear-impression-option mb-0">
                        <span className="dot dot-right"></span>Right Ear
                      </p>
                    )}
                  </Col>
                  <Col xs={2}>
                    {rightSelected && leftSelected && (
                      <div className="text-center link-div">
                        {linked && iteModelLinked ? (
                          <InsertLink
                            className="linked"
                            onClick={() => setLinked(false)}
                          />
                        ) : (
                          <LinkOff
                            onClick={() => setLinked(!linked)}
                            className="unlinked"
                          />
                        )}
                      </div>
                    )}
                  </Col>
                  <Col xs={5}>
                    {leftSelected && (
                      <p className="left-ear-title ear-impression-option ear-impression-option mb-0">
                        <span className="dot dot-left"></span>Left Ear
                      </p>
                    )}
                  </Col>
                  <Col md={6}>
                    {rightSelected && (
                      <Row className="ite-shell-style-row-right">
                        <Col xs={12}>
                          <div className="select">
                            <select
                              value={selectedShellStyleRight.Code}
                              onChange={handleShellStyleChangeRight}
                              disabled={hasSetPresetRight}
                            >
                              {iteShellStyleRight &&
                                iteShellStyleRight.map((shellStyle, index) => {
                                  return (
                                    <option key={index} value={shellStyle.Code}>
                                      {shellStyle.Name}
                                    </option>
                                  );
                                })}
                            </select>
                          </div>
                        </Col>
                      </Row>
                    )}
                  </Col>
                  <Col md={6}>
                    {leftSelected && (
                      <Row className="ite-shell-style-row-left left-side">
                        <Col xs={12}>
                          <div className="select">
                            <select
                              value={selectedShellStyleLeft.Code}
                              onChange={handleShellStyleChangeLeft}
                              disabled={hasSetPresetLeft}
                            >
                              {iteShellStyleLeft &&
                                iteShellStyleLeft.map((shellStyle, index) => {
                                  return (
                                    <option key={index} value={shellStyle.Code}>
                                      {shellStyle.Name}
                                    </option>
                                  );
                                })}
                            </select>
                          </div>
                        </Col>
                      </Row>
                    )}
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        )}
    </div>
  );
};

export default ITEShellStyle;
